import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReaderLayout from "@/components/ReaderLayout";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ReaderLayout />} />
          <Route path="*" element={<ReaderLayout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
